<template>
  <el-form
    :model="adBannerData"
    ref="adBannerData"
    label-width="15%"
    class="demo-brandForm"
    v-loading.body="fetchLoding"
  >
    <el-form-item :label="generateCustomizeString('bannerImage')" prop="banner_pic_url">
      <el-upload
        action="https://upload-z2.qiniup.com"
        :limit="1"
        :drag="true"
        :on-success="handleAvatarSuccess"
        :on-error="handleError"
        :before-upload="beforeAvatarUpload"
        :data="qiniuData"
      >
        <img v-if="banner_pic_url" :src="displayBannerUrl" />
        <div v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{generateCustomizeString('dragFiles')}}
            <em>{{generateCustomizeString('uploadFiles')}}</em>
          </div>
        </div>
        <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
      </el-upload>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('relatedCategories')">
      <el-cascader
        expand-trigger="hover"
        :options="categoriesOptions"
        v-model="selectedCategories"
        @change="handleChange"
        change-on-select
      ></el-cascader>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('sortWeight')" prop="sort_by">
      <el-input v-model="adBannerData.sort_by" type="number"></el-input>
    </el-form-item>
    <el-form-item :label="generateCustomizeString('bannerActivity')" prop="is_show">
      <el-switch
        v-model="adBannerData.is_show"
        :active-text="generateCustomizeString('bannerReady')"
        :inactive-text="generateCustomizeString('bannerWaitForReview')"
      ></el-switch>
    </el-form-item>
    <el-form-item>
      <el-button
        v-if="isEdit"
        type="primary"
        @click="submitForm('brandForm')"
        plain
      >{{generateCustomizeString('update')}}</el-button>
      <el-button
        v-if="!isEdit"
        type="primary"
        @click="submitForm('brandForm')"
      >{{generateCustomizeString('create')}}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

const defaultBannerData = {
  related_data: [],
  sort_by: 0,
  is_show: false,
  picture: ''
}

export default {
  name: 'AdBannerDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      adBannerData: Object.assign({}, defaultBannerData),
      qiniuData: {
        token: ''
      },
      fetchLoding: false,
      categoriesOptions: [],
      banner_pic_url: ''
    }
  },
  methods: {
    generateCustomizeString,
    handleChange() {},
    submitForm(formName) {
      if (this.isEdit) {
        // update
        this.updateBanner()
      } else {
        // create
        this.createBanner()
      }
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = parseInt(response.data[i].id)
              obj.label = response.data[i].name
              // const sub = response.data[i].sub_categories
              // for (let j = 0; j < response.data[i].sub_categories.length; j++) {
              //   var sobj = {}
              //   sobj.value = parseInt(response.data[i].sub_categories[j].id)
              //   sobj.label = response.data[i].sub_categories[j].name
              //   sub[j] = sobj
              // }
              // obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            console.log(this.categoriesOptions)
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBanner() {
      return new Promise((resolve, reject) => {
        request({
          url: 'cms-category-item/' + this.$route.params.bannerId,
          method: 'get'
        })
          .then(res => {
            if (res.status === 0) {
              // 更新数据
              for (const i in this.adBannerData) {
                this.adBannerData[i] = res.data[i]

                if (i === 'is_show') {
                  this.adBannerData.is_show = res.data[i] === 1
                }
              }

              if (res.data['pic_url']) {
                this.banner_pic_url = res.data['pic_url']
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            this.fetchLoding = false
          })
      })
    },
    fetchUploadToken() {
      return new Promise((resolve, reject) => {
        request({
          url: '/upload-token',
          method: 'get'
        })
          .then(res => {
            this.qiniuData.token = res.data['token']
            resolve()
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.adBannerData.picture = res.key

      this.banner_pic_url = 'https://img.nzmai.com.cn/' + res.key
      console.log(this.adBannerData.picture)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    createBanner() {
      var data = {
        related_data: this.adBannerData.related_data,
        sort_by: this.adBannerData.sort_by,
        type: 2,
        is_show: this.adBannerData.is_show,
        picture: this.adBannerData.picture
      }
      request({
        url: 'cms-category-item',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcAdBanner'
            })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updateBanner() {
      var data = {
        related_data: this.adBannerData.related_data,
        sort_by: this.adBannerData.sort_by,
        type: 2,
        is_show: this.adBannerData.is_show,
        picture: this.adBannerData.picture
      }
      request({
        url: 'cms-category-item/' + this.$route.params.bannerId,
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.$router.push({
              name: 'PcAdBanner'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    }
  },
  created() {
    if (this.fetchLoding) return
    this.fetchLoding = true
    Promise.all([this.fetchUploadToken(), this.fetchCategories()])
      .then(result => {
        if (this.isEdit) {
          this.fetchBanner()
        } else {
          this.adBannerData = Object.assign({}, defaultBannerData)
        }
      })
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.fetchLoding = false
      })
  },
  computed: {
    displayBannerUrl() {
      return this.banner_pic_url + '?imageView2/0/w/360/h/200/q/75|imageslim'
    },
    // 查询categories
    selectedCategories: {
      // getter
      get: function() {
        const categoryId = parseInt(this.adBannerData.related_data[0])
        if (categoryId) {
          var i = this.categoriesOptions.length
          while (i--) {
            const obj = this.categoriesOptions[i]
            if (obj.value === categoryId) {
              return [obj.value]
            } else {
              if (obj.children) {
                const array = obj.children
                var j = array.length
                while (j--) {
                  const cobj = array[j]
                  if (cobj.value === categoryId) {
                    return [obj.value, cobj.value]
                  }
                }
              }
            }
          }
        }
        return []
      },
      // setter
      set: function(newValue) {
        this.adBannerData.related_data = [newValue[newValue.length - 1]]
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-brandForm {
  padding: 50px 50px 0px 50px;
}
</style>
